import { lazy, Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';

/**
 * פס האזהרה "מחובר לייצור" הוא כלי פיתוח, ואין לו מה לחפש בטלפון של
 * עובד. הייבוא הוא דינמי ומאחורי import.meta.env.DEV, שהופך ל false
 * בבנייה: הענף מתקפל, אף אחד לא מפנה למודול, והוא נושר מהבאנדל כולו.
 * ייבוא רגיל היה משאיר את הטקסט בפנים גם כשהוא מת.
 */
const ProductionWarning = import.meta.env.DEV
  ? lazy(() =>
      import('./ProductionWarning').then((m) => ({ default: m.ProductionWarning })),
    )
  : () => null;

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
      <Suspense fallback={null}>
        <ProductionWarning />
      </Suspense>
    </Providers>
  );
}
